var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 78,
    viewBox: "0 0 39 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52V26L39 0V26L0 52Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26V52L39 78V52L0 26Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupArrow);
export default __webpack_public_path__ + "static/media/group_arrow.2a84aedd719a71a372695c5bc3505126.svg";
export { ForwardRef as ReactComponent };